import { apiConstants } from '../../constants/endpoints';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonService } from '../../services/common/common.service';
import { MsalService } from '@azure/msal-angular';
import { Router } from '@angular/router';
import { HttpService } from '../../services/http/http.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {
  isExpanded = false;
  userName: string | null | undefined;
  flName: string | undefined;
  requestInProgress = false;
  uploadConfimation = false;
  previousLocalStorageValue: string | undefined | null;
  headerTitle = ""
  returnRouterLink: string = '';
  showRouterLink: boolean;
  isDeviceDisabled: boolean = false;

  constructor(
    private common: CommonService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private msalService: MsalService,
    private route: Router,
    private http:HttpService
  ) {
    this.uploadConfimation = this.data.uploadConfirmation;
  }

  ngOnInit() {
    this.loadUserName();

    this.common.requestInProgress$.subscribe(
      (preogressData: any) => (this.requestInProgress = preogressData)
    );

    this.previousLocalStorageValue = localStorage.getItem('email') ? localStorage.getItem('email') : '';
    this.common.title$.subscribe(
      (titleData: any) => {
        this.headerTitle = titleData;
        this.showRouterLink = titleData.startsWith(' Device') ? true : false; // space added before device to identify only that device screen
      }
    );

    this.common.previousUrl$.subscribe(
      (url: any) => (this.returnRouterLink = url));

    this.common.setDeviceDisable$.subscribe((isdeviceDisabled: boolean) => this.isDeviceDisabled = isdeviceDisabled)
  }

  navigateBack() {
    sessionStorage.setItem("backFrom", this.route.url);
    this.route.navigateByUrl(this.returnRouterLink);
  }

  loadUserName() {
    this.userName = localStorage.getItem('userName') ? localStorage.getItem('userName') : '';
    const fullName = this.userName?.split(' ') || '';
    this.flName = fullName[0]?.charAt(0) + fullName[1]?.charAt(0);
  }

  logout() {
    this.http.get(`${apiConstants.tokenBlacklist}?isRequestedFromLogout=true`).subscribe((data: any) => {
      localStorage.clear();
      sessionStorage.clear();
      this.msalService.logoutRedirect();
    });
  }

  // Make the sidebar toggle
  toggle() {
    this.isExpanded = !this.isExpanded;
    this.common.setData(this.isExpanded);
  }

  checkLocalStorageChanges() {
    const currentLocalStorageValue = localStorage.getItem('email');
    if (currentLocalStorageValue !== this.previousLocalStorageValue) {
      window.location.reload();
    }
  }
}
